import { isNumber, isUndefined } from 'lodash';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import cx from 'classnames';
import { Icon } from 'components/Icon';
import { ListItemProps, OrderedListProps, UnorderedListProps } from 'components/Lists/types';

const ListItem: React.FC<ListItemProps> = ({ children, number, className }) => {
  return (
    <li className={twMerge('flex items-start gap-16', className)}>
      {isNumber(number) && (
        <div className="w-32 h-32 bg-orange-300 rounded-full flex items-center justify-center shrink-0">{number}</div>
      )}
      {isUndefined(number) && (
        <div className="w-24 h-24 flex items-center justify-center shrink-0">
          <Icon className="w-8" name="CirclesTarget" />
        </div>
      )}
      <div>{children}</div>
    </li>
  );
};

type ListComposition = {
  Item: typeof ListItem;
};

export const UnorderedList: React.FC<UnorderedListProps> & ListComposition = ({
  children,
  as = 'ul',
  className,
  useDefaultMargins,
  ...rest
}) => {
  return React.createElement(
    as,
    {
      className: twMerge(
        cx('flex flex-col gap-40 sm-d:gap-24', {
          'mb-24 last:mb-0': useDefaultMargins,
        }),
        className,
      ),
      ...rest,
    },
    children,
  );
};

export const OrderedList: React.FC<OrderedListProps> & ListComposition = props => <UnorderedList as="ol" {...props} />;

UnorderedList.Item = ListItem;
OrderedList.Item = ListItem;
